import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import moment from "moment";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";
import CustomizedTextField from "../../components/Input/CustomizedTextField";
import CustomizedSelect from "../../components/Input/CustomizedSelect";
import DatePicker from "../../components/Input/DatePicker";
import "../../utils.css";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { InputLabel } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import { getEPICategories } from "../../redux/epi/epiActions";
import { submitAsDraft } from "../../redux/epi/epiEditionActions";
import { throwWarning, throwInfo } from "../../lib/error_helper";

const styles = {
	appBar: {
		position: "relative",
	},
	flex: {
		flex: 1,
	},
};

class DeclareEquipment extends Component {
	constructor(props) {
        super(props);		

		this.state = {
			category: 0,
			brand: "",
			model: "",
			serial_number: "",
			commissioning_date: null,
	    	brand_required: false,
			model_required: false,
			serial_number_required: false,
			check_periodicity: null
        };

		this.props.getEPICategories(props.activeUser);
    }

	shouldComponentUpdate(nextProps, nextState) {
		if (!nextProps.epiCategories || !this.props.epiCategories) return false;

		if (nextState.brand_required !== this.state.brand_required ||
			nextState.model_required !== this.state.model_required ||
			nextState.serial_number_required !== this.state.serial_number_required ||
			nextState.commissioning_date !== this.state.commissioning_date
			) return true;

		if (this.state.brand_required && nextState.brand !== this.state.brand ||
			this.state.model_required && nextState.model !== this.state.model ||
			this.state.serial_number_required && nextState.serial_number !== this.state.serial_number ||
			nextState.category !== this.state.category
		)    return true;

		return (
			nextProps.epiCategories !==
				this.props.epiCategories
		);
	}

	onCategoryChange(e) {
		let id = e.target.value;
		let category = this.props.epiCategories.find(c => c.id === id);
		if (category) {
			this.setState({ category: id, brand_required: category.brand_required, model_required: category.model_required, serial_number_required: category.serial_number_required,
				check_periodicity: category.check_periodicity
			});
		}
    }

	updateBrand(brand) {
        this.setState({ brand: brand });
    }

	updateModel(model) {
        this.setState({ model: model });
    }

	updateSerialNumber(serial_number) {
        this.setState({ serial_number: serial_number });
    }

	updateCommissioningDate(commissioning_date) {
        this.setState({ commissioning_date: commissioning_date });
    }

	askUser() {
		this.props.throwInfo({
			title: "Les champs renseignés ne seront plus modifiables après validation. Voulez-vous les sauvegarder définitivement ?",
			dismissAfter: 0,
			forceDismissible: true,
			buttons: [{name: "Oui", primary: true, onClick: () => {this.validateDeclaration()}}, {name: "Non", primary: false, onClick: () => {}}]
		});
	}

	validateDeclaration() {
		if (!this.state.category) 
		{
			this.props.throwWarning({
				title: "Veuillez sélectionner une catégorie.",
			});
            return;
		}
		if (!this.state.brand && this.state.brand_required || 
			!this.state.model && this.state.model_required || 
			!this.state.serial_number && this.state.serial_number_required ||
			!this.state.commissioning_date) 
		{
			this.props.throwWarning({
				title: "Veuillez renseigner tous les champs obligatoires avant de valider la déclaration de l'équipement (champs marqués par une astérisque).",
			});
            return;
		}

		let equipmentEPIState = {
			commissioning_date: this.state.commissioning_date ? this.state.commissioning_date.format('YYYY-MM-DD') : null,
			company_id: this.props.loggedEmployee.company_id.id,
			emp_id: this.props.activeUser.emp_id,
			serial_number: this.state.serial_number,
			model: this.state.model,
			brand: this.state.brand,
			department_id: this.props.loggedEmployee.department_id.id,
			equipment_id: this.state.category,
			state: 'draft'
		};
		this.props.submitAsDraft(equipmentEPIState, this.props.activeUser,  () => {
            this.props.history.push("/epis");
        });
    }

	render() {
		let rowsCategoryList = [];

		if (this.props.epiCategories && this.props.epiCategories.length > 0) {
			let i = 0;
			this.props.epiCategories.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
			this.props.epiCategories.forEach((c) => {
				if (c.show_in_employee_equipment_list && c.active && !c.agency_equipment) {
					rowsCategoryList.push(
						<MenuItem key={i} value={c.id}>
							{c.name}
						</MenuItem>
					)
					i = i + 1;
				}				
			});
		}

		return (
			<div className="div-container">
				<Card className="col-lg-12 col-md-12 col-sm-12 col-12 card card-margin-top without-side-padding">
                	<CardContent className="without-side-padding">
						<div className="row col-lg-12 col-md-12 col-sm-12 col-12">						
							<div className="col-lg-12 col-md-12 col-sm-12 col-12">
								<Typography variant="h6">Déclaration d&apos;un équipement</Typography>
								<FormControl className="full_size control-margin-top" error={!this.state.category}>
									<InputLabel id="category-filter-label">Catégorie</InputLabel>
									<CustomizedSelect
										label="Catégorie"
										labelId="category-filter-label"
										id="category-filter"
										inputProps={{ name: "category-filter", id: "category-filter" }}
										placeholder="Category"
										className="full_size select-light-background"
										menuclasses="select-popup"
										onChange={this.onCategoryChange.bind(this)}
										defaultValue={""}
										helperText={!this.state.category ? "Veuillez renseigner ce champ" : ""}
									>
										{rowsCategoryList}
									</CustomizedSelect>
								</FormControl>
								<CustomizedTextField
									id="brand"
									label={"Marque"}
									className={"full_size control-margin-top"} 
									helperText={(this.state.brand_required && !this.state.brand ? "Veuillez renseigner ce champ" : "")}
									onChange={(e) => {
										this.updateBrand(e.target.value);
									}}
									error={(this.state.brand_required && !this.state.brand)}	
								/>
								<CustomizedTextField
									id="model"
									label={"Modèle"}
									className={"full_size control-margin-top"} 
									helperText={(this.state.model_required && !this.state.model ? "Veuillez renseigner ce champ" : "")}
									onChange={(e) => {
										this.updateModel(e.target.value);
									}}
									error={(this.state.model_required && !this.state.model)}	
								/>
								<CustomizedTextField
									id="serial_number"
									label={"Numéro de série"}
									className={"full_size control-margin-top"} 
									helperText={(this.state.serial_number_required && !this.state.serial_number ? "Veuillez renseigner ce champ" : "")}
									onChange={(e) => {
										this.updateSerialNumber(e.target.value);
									}}
									error={(this.state.serial_number_required && !this.state.serial_number)}	
								/>
								<DatePicker
									id="commissioning_date"
									label="Date de mise en service"
									emptyLabel="La date est invalide"
									invalidDateMessage="La date est invalide"
									invalidLabel="La date est invalide"
									format="DD/MM/YYYY"
									className="full_size control-margin-top"
									helperText={!this.state.commissioning_date ? "Veuillez renseigner ce champ" : ""}
									onChange={this.updateCommissioningDate.bind(this)}
									error={(!this.state.commissioning_date)}
									fullWidth={true}
									value={this.state.commissioning_date}
								/>
							</div>		
							<div className="ms-auto col-auto mt-3">
									<Button style={{boxShadow: "none"}} variant="contained" endIcon={<SaveIcon />}
										onClick={this.askUser.bind(this)}
										disabled={(!this.state.brand && this.state.brand_required) || (!this.state.model && this.state.model_required) || (!this.state.serial_number && this.state.serial_number_required)
										|| !this.state.commissioning_date || !this.state.category}
									>
										Déclarer
									</Button>
								</div>
						</div>
					</CardContent>
            	</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		epiCategories: state.equipmentsEPI.epiCategories,
		loggedEmployee: state.loggedEmployee.loggedEmployee
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		throwWarning: (warnObj) => dispatch(throwWarning(warnObj)),
		throwInfo: (infoObj) => dispatch(throwInfo(infoObj)),
		getEPICategories: (user) => dispatch(getEPICategories(user)),
		submitAsDraft: (equipmentEPIState, user, onSuccess) => dispatch(submitAsDraft(equipmentEPIState, user, onSuccess))
	};
};

export default compose(withRouter, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(DeclareEquipment);
